module.exports = __webpack_public_path__ + "static/signal-24714b54fa2659c4594d2ce9d17f1d38.svg";